import { Post, PostBlock } from '../types/content';
import { posts as rawPosts } from './posts';

/* Blog posts as shown on the site. Trip Ink is now booked by full-day appointment, so the old
   walk-in wording in the original articles is swapped for appointment wording here (David, 2026-10-14). */
const SWAPS: [RegExp, string][] = [
  [/Open to Walk-Ins and Appointments/g, 'Built Around Appointments'],
  [
    /Trip Ink Tattoo caters to all types of clients—from those who plan their tattoos for months to spontaneous walk-ins inspired by the energy of the Strip\. Open seven days a week, the studio is well-prepared to accommodate visitors who decide mid-vacation that it’s time to get inked\./g,
    'Trip Ink Tattoo works by appointment, so your artist and your day are set aside for you. Open seven days a week, the studio can fit visitors who decide mid-vacation that it’s time to get inked. Send a booking request and the shop will confirm your artist and date.',
  ],
  [/Trip Ink offers both options\. Walk-ins are welcome, but if you have a specific artist or design in mind, it’s best to book in advance\./g, 'Yes. Trip Ink works by appointment. Send a booking request and the shop will confirm your artist, your date and your deposit.'],
  [/Book early if possible: While walk-ins are welcome, scheduling ensures your preferred artist is available\./g, 'Book early if possible: scheduling ensures your preferred artist is available.'],
  [/Book a consultation, walk in with an idea, or simply browse the gallery\./g, 'Send a booking request, bring your idea, or simply browse the gallery.'],
  [/Whether you’re walking in with a clear concept/g, 'Whether you’re coming in with a clear concept'],
];

const clean = (s: string) => SWAPS.reduce((t, [re, to]) => t.replace(re, to), s);
const cleanBlock = (b: PostBlock): PostBlock => (b.type === 'ul' ? { ...b, items: b.items.map(clean) } : { ...b, text: clean(b.text) });

export const posts: Post[] = rawPosts.map((p) => ({
  ...p,
  title: clean(p.title),
  excerpt: clean(p.excerpt),
  blocks: p.blocks.map(cleanBlock),
  faqs: p.faqs?.map((f) => ({ q: clean(f.q), a: clean(f.a) })),
}));
